<template>
  <b-form-group
    label="Kısa Açıklama"
    label-for="summary"
  >
    <validation-provider
      #default="{ errors }"
      name="Kısa Açıklama"
      rules="required"
    >
      <b-form-textarea
        id="summary"
        v-model="dataItem.summary"
        placeholder="Kısa Açıklama"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ProjectSummary',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
